import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import Footer from "../generic-template/Footer";
import ScrollToTop from "../generic-template/ScrollToTop";
import DropdownUser from "./DropdownUser";
import NavMenuDynamic from "./NavMenuDynamic";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import logo from "../../resources/images/logo/logo_teccc.png";
import { userStartLoadPreferences } from "../../app/actions/userActions";
import { parseEnabledLanguages } from "../../app/helpers/uiLanguagesHelper";
import { resolveUiTheme } from "../../app/helpers/uiThemeHelper";
import "./theme-surface.css";

const NavbarDynamicReloaded = () => {
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();

  const { isUserAuthenticated } = useSelector((state) => state.auth);
  const { userPreferences } = useSelector((state) => state.user);
  const configuration = useSelector((state) => state.configuration);

  const { menus } = useSelector((state) => state.menu);
  const [click, setClick] = useState(false);
  const [clock, setClock] = useState(() => new Date());

  const theme = resolveUiTheme({
    enabled: configuration?.uiThemeEnabled,
    preference: userPreferences?.theme,
    nightStart: configuration?.uiThemeNightStart,
    nightEnd: configuration?.uiThemeNightEnd,
    now: clock,
  });

  useEffect(() => {
    if (isUserAuthenticated) {
      dispatch(userStartLoadPreferences());
    }
  }, [dispatch, isUserAuthenticated]);

  useEffect(() => {
    if (!isUserAuthenticated || !userPreferences?.language) return;
    const enabled = parseEnabledLanguages(configuration?.uiLanguagesEnabled);
    if (!enabled.includes(userPreferences.language)) return;
    const current = String(i18next.resolvedLanguage || i18next.language || "").slice(0, 2);
    if (current !== userPreferences.language) {
      i18next.changeLanguage(userPreferences.language);
    }
  }, [configuration?.uiLanguagesEnabled, isUserAuthenticated, userPreferences?.language]);

  useEffect(() => {
    if (String(configuration?.uiThemeEnabled) !== "true" || userPreferences?.theme !== "auto") return undefined;
    const timer = setInterval(() => setClock(new Date()), 60000);
    return () => clearInterval(timer);
  }, [configuration?.uiThemeEnabled, userPreferences?.theme]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme || "light");
  }, [theme]);

  const [navState, setNavState] = useState(false);

  const closeMobileMenu = () => {
    trackEvent({ funComponent: "HookButton", event: "HookButton-Clicked" });
    setClick(false);
    setNavState(false); // <--- ESTA ES LA LÍNEA QUE FALTA
  };

  const IsLoggedIn = () => {
    return (
      <NavMenuDynamic menus={[...menus]} isClicked={click} closeMobileMenu={closeMobileMenu} />
    );
  }

  return (
    <div data-theme={theme} className="app-container">
      <ScrollToTop />

      <nav className="nav-bar-r">
        <div className="brand-container">
          <div className="brand">
            <img src={logo} alt="logo" style={{ height: "70px" }} />
          </div>
          <div className="toggle-container">
            <div className="toggle" onClick={() => setNavState(!navState)}>
              {navState ? <MdClose /> : <GiHamburgerMenu />}
            </div>
          </div>
        </div>

        <div className={`container-dynamic ${navState ? "nav-visible" : ""}`}>
          <div className="close-button" onClick={closeMobileMenu}>
            <MdClose /> {/* Ícono de cierre */}
          </div>
          <ul className="list-dynamic">
            {isUserAuthenticated && (
              <IsLoggedIn />
            ) 
          }
          </ul>
        </div>

        <div className="nav-display-icons">
          <DropdownUser />
        </div>

      </nav>
      <main>
        <section>
          <div className="children-section">
            <div className="children-app">
              {/*<div className="container">*/}
                <Outlet /> {/* Contenido dinámico */}
              {/*</div>*/}
            </div>
          </div>
        </section>
      </main>
      <Footer /> {/* Footer siempre abajo */}
    </div>
  );
};

export default NavbarDynamicReloaded;
